export default () => {
    let wrapper = document.querySelectorAll('.js-apts');

    if (wrapper.length === 0) {
        return;
    }

    let triggeredTracking  = false;
    let aptPanoramaModal = document.getElementById('project-apt-panorama-modal');
    let aptPanoramaIframe = document.getElementById('project-apt-panorama');
    let aptPanoramaClose = document.getElementById('js-close-panorama');
    let aptGlobalProjectsSub = document.querySelectorAll('.js-global-projects-inputs');
    let aptGlobalAptOfInterest = document.querySelector('.js-mc-apt-of-interest');

    aptPanoramaClose.addEventListener('click', function (e) {
        e.preventDefault();
        aptPanoramaModal.classList.remove('active');
    });

    function getImageSize(src, callback) {
        var image = new Image();

        image.src = src;

        image.addEventListener('load', function () {
            callback(image.width, image.height);
        });
    }

    /**
     * Apt custom tracking function
     */
    let tracking = function () {
        if (!triggeredTracking && window.dataLayer) {
            triggeredTracking = true;
            dataLayer.push({'event':'eventTracking','eventCategory':'Boligsok','eventAction':'search'});
        }
    };

    [].forEach.call(wrapper,function (item) {
        let controls = item.querySelector('.js-apts-controls');
        let innerControls = controls.querySelectorAll('.js-apt-control');
        let priceValue = controls.querySelector('input[name=js-price-value]');
        let priceDisplayVal = controls.querySelector('.js-price-label');
        let priceDisplayValBig = controls.querySelector('.js-price-big-display');
        let roomsValue = controls.querySelectorAll('input[name=js-rooms-value]');
        let roomsDisplayVal = controls.querySelector('.js-rooms-label');
        let spaceContainer = controls.querySelector('[data-space-container]');
        let spaceValue = [];
        let filter = controls.querySelector('button[data-submit]');
        let roomsTotal = [];
        let spaceTotal = [];

        let innerWrapper = item.querySelector('.js-apts-display');
        let tableRow = item.querySelectorAll('table tbody .record');
        let tableRowTrigger = item.querySelectorAll('.js-trigger-record');
        let showBox = item.querySelector('.js-show-box');
        let showBoxTrigger = item.querySelector('.js-show-box-trigger');
        let showBoxTriggerCount = showBoxTrigger.querySelector('.total .val');

        let contactTrigger = item.querySelectorAll('.js-trigger-contact');

        let recordWrapper = item.querySelector('.js-info-record');

        let show2d = item.querySelectorAll('.js-show-2d');
        let show3d = item.querySelectorAll('.js-show-3d');
        let floorNav = item .querySelectorAll('.js-floor-nav');
        let floors = item.querySelectorAll('.js-floor');

        tableRowTrigger.forEach(function (tr) {
            tr.addEventListener('click', function (e) {
                let imgs = this.parentNode.querySelectorAll('img');

                imgs.forEach(function (img) {
                    if (!img.src) {
                        img.src = img.dataset.src;

                        getImageSize(img.src, function (width, height) {
                            let panoLink = img.nextElementSibling;

                            if (!panoLink || panoLink.tagName !== 'A') {
                                return;
                            }

                            let xPos = panoLink.dataset.x;
                            let yPos = panoLink.dataset.y;
                            let panoHtml = panoLink.dataset.pano;

                            panoLink.style.left = (xPos / width * 100) + '%';
                            panoLink.style.top = (yPos / height * 100) + '%';

                            panoLink.addEventListener('click', function (e) {
                                e.preventDefault();

                                aptPanoramaModal.classList.add('active');
                                aptPanoramaIframe.src = panoHtml;
                            });
                        });
                    }
                });

                if (this.parentNode.classList.contains('opened')) {
                    this.parentNode.classList.remove('opened');
                    innerWrapper.classList.add('partial');
                } else {
                    for (let i = 0; i < tableRow.length; i++) {
                        tableRow[i].classList.remove('opened');
                    }

                    innerWrapper.classList.remove('partial');
                    this.parentNode.classList.add('opened');
                }
            });
        });

        showBoxTrigger.addEventListener('click', function (e) {
            innerWrapper.classList.remove('partial');
        });

        show2d.forEach(function (i) {
            i.addEventListener('click', function (e) {
                e.preventDefault();
                let infoBox = i.closest('.js-info');
                infoBox.classList.remove('with_3d');
                infoBox.classList.add('with_2d');
            });
        });

        show3d.forEach(function (i) {
            i.addEventListener('click', function (e) {
                e.preventDefault();
                let infoBox = i.closest('.js-info');
                infoBox.classList.remove('with_2d');
                infoBox.classList.add('with_3d');
            });
        });

        [].forEach.call(contactTrigger, function (item) {

            item.addEventListener('click', function () {
                let dataProject = this.dataset.project || '';
                let aptOfInterest = this.dataset.apt || '';

                aptGlobalProjectsSub.forEach(function (item) {
                    item.checked = item.id === dataProject || false;
                });

                if (aptOfInterest) {
                    aptGlobalAptOfInterest.value = aptGlobalAptOfInterest.value + aptOfInterest + ', '
                }
            });
        });

        floorNav.forEach(function (i) {
            i.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                floorNav.forEach(function (fn) {
                    fn.classList.toggle('active');
                });
                floors.forEach(function (f) {
                    f.classList.toggle('active');
                });
            });
        });

        function filterSearch() {
            if (!priceValue)
                return;

            priceValue.value = priceValue.value.replace(/ /g, '');
            let pValue = priceValue.value.split(',');
            let totalCount = 0;

            for (let r = 0; r < tableRow.length; r++) {
                let record = tableRow[r];
                let currentSizeData = parseInt(record.dataset.size);
                record.classList.remove('opened');
                if (
                    (parseInt(pValue[0]) <= parseInt(record.dataset.price) && parseInt(record.dataset.price) <= parseInt(pValue[1]))
                    &&
                    ((roomsTotal === 0 || roomsTotal.length === 0) || (roomsTotal.includes(parseInt(record.dataset.room))))
                    &&
                    (spaceTotal.length === 0 || (
                        spaceTotal.some(function (item, index) {
                            return item[0] <= currentSizeData && currentSizeData <= item[1];
                        })
                    ))
                ) {
                    record.classList.remove('hidden');
                    totalCount++;
                } else {
                    record.classList.add('hidden');
                }
            }

            showBoxTriggerCount.innerHTML = totalCount;
            totalCount < 9 ? innerWrapper.classList.remove('partial') : innerWrapper.classList.add('partial');

            tracking();
        }

        filter.addEventListener('click', function () {
            filterSearch();
        });

        if (priceValue) {
            priceValue.onchange = function () {
                calcPriceOnChange();
            };
        }

        function calcPriceOnChange() {
            if (!priceValue.value)
                return;

            let priceValCur = priceValue.value.split(',');
            let minPriceVal = calcMillion(priceValCur[0].replace(/\s/g, ''));
            let maxPriceVal = calcMillion(priceValCur[1].replace(/\s/g, ''));

            priceDisplayVal.textContent = minPriceVal + ' - ' + maxPriceVal;
            priceDisplayValBig.innerHTML = '<span>' + minPriceVal + '</span>' + ' - ' + '<span>' + maxPriceVal + '</span>';
            filterSearch();
        }

        function calcMillion(num) {
            let parsedNum = parseFloat(num);
            return ((Math.abs(parsedNum / 1000000)).toFixed(2)).replace(/(\.0+|\.*0+)$/, '') + 'm';
        }

        // spaceValue.onchange = function () {
        //     filterSearch();
        //     console.log(spaceValue.value);
        // };

        (function () {
            let minSpace = parseInt(spaceContainer.dataset.min);
            let maxSpace = parseInt(spaceContainer.dataset.max);
            let checkboxesSpace = spaceContainer.querySelector('.custom-checkboxes');
            let lastQuarter = 0;
            let irit;

            let fourthDifference = Math.floor((maxSpace - minSpace) / 4);

            for (irit = 1; irit <= 4; irit++) {
                let currentDif = fourthDifference * irit;
                let currentMaxValue = minSpace + currentDif;
                let currentMinValue = currentMaxValue - fourthDifference;
                lastQuarter = currentMaxValue;
                let field,
                    label,
                    input,
                    span;
                field = document.createElement('div');
                label = document.createElement('label');
                input = document.createElement('input');
                span = document.createElement('span');

                field.setAttribute('class', 'field');

                input.setAttribute('type', 'checkbox');
                input.setAttribute('name', 'js-space-value');
                input.setAttribute('value', irit !== 4 ? '[' + currentMinValue + ',' + currentMaxValue + ']' : '[' + currentMinValue + ',' + maxSpace + ']');
                span.setAttribute('class', 'label');
                span.innerText = irit !== 4 ?
                    currentMinValue + ' - ' + currentMaxValue + ' m2'
                    :
                    currentMinValue + ' - ' + maxSpace + ' m2';

                label.appendChild(input);
                label.appendChild(span);
                field.appendChild(label);

                checkboxesSpace.appendChild(field);
            }

            spaceValue = controls.querySelectorAll('input[name=js-space-value]');

            spaceValue.forEach(function (item) {
                item.onchange = function (e) {
                    spaceOnChange();
                }
            });

            function spaceOnChange() {
                spaceTotal = [];

                [].some.call(spaceValue, function (item, index) {

                    if (item.checked) {
                        spaceTotal.push(JSON.parse(item.value));
                    }
                });

                filterSearch();
            }

        }());

        roomsValue.forEach(function (item) {
            item.onchange = function (e) {
                roomsOnChange();
            }
        });

        function roomsOnChange() {
            roomsTotal = [];
            [].some.call(roomsValue, function (item, index) {

                if (index === 0 && item.checked) {
                    roomsTotal = 0;
                    return true;
                } else if (item.checked) {
                    roomsTotal.push(parseInt(item.value));
                    return false;
                }
            });

            editRoomsLabel(roomsTotal);

            filterSearch();
        }

        function editRoomsLabel(currentTotal) {
            if (!currentTotal || !currentTotal.length) {
                roomsDisplayVal.textContent = 'Alle';
            } else {
                console.log(currentTotal);
                roomsDisplayVal.textContent = currentTotal.join(', ') + '-roms';
            }
        }

        innerControls.forEach(function (item) {
            item.addEventListener('click', function () {
                this.classList.toggle('active');
            })
        });

        calcPriceOnChange();
        editRoomsLabel(roomsTotal);
    });
}